import { isObject } from '../../../../utils'

export const buildSchoolQuota = (quota, coloredSchools) => {
  if (!isObject(quota.school)) {
    const school = coloredSchools.find(isQuotaInSchool(quota))

    if (isObject(school) && school.color) {
      quota.school.color = school.color
    }
  }

  return quota
}

export const isQuotaInSchool = quota => school => school.id === quota.school.id
export const isQuotaInSchools = schools => quota => schools.some(isQuotaInSchool(quota))
